import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select, { createFilter } from "react-select";
import CustomTable from "./CustomTable";
import DialogModal from "./DialogModal";
import AddAnswer from "../../pages/managements/question/AddAnswer";

const FormComponent = ({
  title,
  setTitle,
  description,
  setDescription,
  isEditMode,
  isAddMode,
  users = [],
  selectedUsers,
  setSelectedUsers,
  onViewAnswer,
  columns,
  data,
}) => {
  const answerRef = useRef(null);
  return (
    <div>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Title
        </label>
        <input
          type="text"
          className="block w-full border border-gray-300 rounded-lg py-2 px-3 
        text-gray-700 focus:border-blue-500 focus:ring-blue-500 focus:outline-none"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Description
        </label>
        <ReactQuill
          value={description}
          onChange={setDescription}
          placeholder="Write the question description here..."
          className="border border-gray-300 rounded-lg mb-4"
        />
      </div>

      {isEditMode && (
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Answers
          </label>

          {data.length > 0 ? (
            <CustomTable
              columns={columns}
              data={data}
              onViewAnswer={onViewAnswer}
            />
          ) : (
            <div className="text-black text-sm mb-2">
              Oops No answers available!
            </div>
          )}

          <button
            onClick={() => answerRef.current.openModal()}
            className="mt-2 px-4 py-2 bg-[#1C2434] text-white hover:bg-[#1C2434] font-semibold rounded-lg 
           transition duration-200"
          >
            Add Answer
          </button>
        </div>
      )}

      {isAddMode && (
        <div className="mb-4 text-gray-800 text-sm">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select User to Answer:
          </label>
          <Select
            options={users}
            value={selectedUsers}
            onChange={setSelectedUsers}
            filterOption={createFilter({ ignoreAccents: false })}
            placeholder="Search and select users"
            className="basic-single"
            classNamePrefix="select"
          />
        </div>
      )}

      <DialogModal ref={answerRef}>
        <AddAnswer />
      </DialogModal>
    </div>
  );
};

export default FormComponent;
